import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "parameter-checkbox" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_radio_button = _resolveComponent("app-radio-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.booleanParameterOptions, (option) => {
      return (_openBlock(), _createBlock(_component_app_radio_button, {
        key: String(option.value),
        modelValue: _ctx.theModel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel) = $event)),
        "radio-value": option.value,
        name: _ctx.radioName,
        text: option.label,
        disabled: !_ctx.editable
      }, null, 8, ["modelValue", "radio-value", "name", "text", "disabled"]))
    }), 128))
  ]))
}